"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileFilter = TileFilter;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@iconify/react");
function TileFilter(props) {
    var title = props.title, options = props.options, selected = props.selected, onChange = props.onChange, icon = props.icon;
    if (options.length === 0)
        return null;
    var allSelected = selected.length === options.length;
    var toggle = function (key) {
        var isOn = selected.includes(key);
        // From "everything", the first click means "only this one" — narrowing, which is what a person
        // reaching for a filter intends. Otherwise it is a plain toggle.
        if (allSelected) {
            onChange([key]);
            return;
        }
        var next = isOn ? selected.filter(function (k) { return k !== key; }) : __spreadArray(__spreadArray([], selected, true), [key], false);
        // Never leave nothing selected: an empty row shows an empty table with no way back except guessing.
        onChange(next.length === 0 ? options.map(function (o) { return o.key; }) : next);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-1.5", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-1.5", children: [icon && (0, jsx_runtime_1.jsx)(react_1.Icon, { icon: icon, className: "text-sm text-gray-400" }), (0, jsx_runtime_1.jsx)("span", { className: "text-[11px] font-semibold uppercase tracking-wide text-gray-500", children: title }), !allSelected && ((0, jsx_runtime_1.jsx)("button", { type: "button", className: "text-[11px] font-medium text-primary hover:underline", onClick: function () { return onChange(options.map(function (o) { return o.key; })); }, children: "reset" }))] }), (0, jsx_runtime_1.jsx)("div", { className: "grid gap-2", style: { gridTemplateColumns: "repeat(".concat(options.length, ", minmax(0, 1fr))") }, children: options.map(function (o) {
                    var on = selected.includes(o.key);
                    return ((0, jsx_runtime_1.jsxs)("button", { type: "button", onClick: function () { return toggle(o.key); }, "aria-pressed": on, className: [
                            "flex flex-col items-start rounded-md border px-2.5 py-1.5 text-left transition-colors",
                            on ? "border-primary/30 bg-primary/5" : "border-gray-200 bg-white opacity-50 hover:opacity-80",
                        ].join(" "), children: [(0, jsx_runtime_1.jsx)("span", { className: "truncate text-[11px] leading-tight text-gray-500", title: o.label, children: o.label }), (0, jsx_runtime_1.jsx)("span", { className: ["text-base font-semibold leading-tight tabular-nums", on ? "text-primary" : "text-gray-400"].join(" "), children: o.count })] }, o.key));
                }) })] }));
}
